import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { safeRedirect } from '../utils/navigationUtils';

const PrivateRoute = () => {
  const token = localStorage.getItem('token');

  // Use useEffect to handle safe redirection if not authenticated
  useEffect(() => {
    if (!token) {
      safeRedirect('/login');
    }
  }, [token]);

  // Return Outlet if authenticated, otherwise null during redirect
  return token ? <Outlet /> : null;
};

export default PrivateRoute;